//angular imports
import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { FormGroup } from '@angular/forms';

//local imports
import { Transforms } from '@app/shared';
import { AbstractStatusModel } from '@app/catalog-common';

@Component({
    selector: 'status-selection-list',
    templateUrl: './status-selection-list.component.html',
    styleUrl: './status-selection-list.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class StatusSelectionListComponent {

    public statuses = input.required<AbstractStatusModel[]>();
    public id = input.required<string>();
    public formGroup = input.required<FormGroup>();
    public label = input<string>("Status");
    public required = input(false, {
        transform: Transforms.toBoolean
      });
}
